
var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function MiddlewareIE() {

    }

    MiddlewareIE.prototype.GetCerts=function (param) {

    };

    MiddlewareIE.prototype.Sign=function (param) {

    };

    $m.MiddlewareIE=MiddlewareIE;

})(HebcaMiddleware);
